/**
 * Google AdSense publisher ID.
 *
 * This is intentionally hardcoded (not read from settings) because Google's
 * verifier crawler does not execute JavaScript, so the same ID must appear
 * in static `public/index.html` and `public/ads.txt`. To change accounts:
 *   1. Update the value below
 *   2. Update `<meta name="google-adsense-account">` and the `<script>` tag in
 *      `frontend/public/index.html`
 *   3. Update the line in `frontend/public/ads.txt`
 *   4. Redeploy
 */
export const ADSENSE_PUBLISHER_ID = "ca-pub-5780682619799625";
